import type { InjectionKey, TemplateRef } from "vue";
import type FileUploadDialog from "@/components/FileUploadDialog.vue";

export const fileUploadDialogKey: InjectionKey<TemplateRef<InstanceType<typeof FileUploadDialog>>> = Symbol("fileUploadDialog");
